import { WidgetDefinition } from '../models/WidgetDefinition';

export const BadValuesTableWidgetDefinition: WidgetDefinition = {
    baseType: 'badValuesTable',
    group: 'Charts',
    highlights: ['A table of bad tags'],
    icon: 'fa-table',
    sortingOrder: 9000,
    title: 'Table of bad values',
    type: 'badValuesTable'
};